module.exports = __webpack_public_path__ + "ico-crypto-crv.svg?d756baa6a49d3f0ce6bd6836f58e5a40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-crv.svg
// module id = 1160
// module chunks = 2